import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { ReportsState, LoadOther, getOtherLoading, getCache } from '../store';
import { tap, take, map, filter, switchMap } from 'rxjs/operators';
import { ReportCache } from 'core-lib';

@Injectable({
    providedIn: 'root'
})
export class OtherGuard  {

    constructor(private store: Store<ReportsState>) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.store.pipe(
            select(getCache),
            filter(cache => !!cache),
            take(1),
            switchMap(cache => this.checkstore(cache))
        );
    }

    checkstore(cache: ReportCache): Observable<boolean> {
        return this.store.pipe(
            select(getOtherLoading),
            tap(loading => {
                if (!loading)
                    this.store.dispatch(new LoadOther({ cacheKey: cache.cache_key, crosstab: cache.report_type === 'crosstab' }));
            }),
            take(1),
            map(() => true)
        );
    }

}
